import styled from "styled-components";

import { Box } from "../Box/Box";

export const TableFilterLayout = styled(Box)`
    display: grid;
    row-gap: 1rem;
`;
